import React, { useState } from 'react';
import {
  Popover,
  Grid,
  IconButton,
  Typography,
  makeStyles
} from '@material-ui/core';
import { AddCircleOutline, ExpandLess } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    borderRadius: '12px',
    padding: '8px',
    maxWidth: '400px',
    '&.compact': {
      maxWidth: '320px',
    }
  },
  reactionButton: {
    fontSize: '20px',
    padding: '8px',
    minWidth: '40px',
    minHeight: '40px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      transform: 'scale(1.1)',
    }
  },
  expandButton: {
    padding: '8px',
    minWidth: '40px',
    minHeight: '40px',
    color: theme.palette.text.secondary,
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: '8px',
  },
  collapseButton: {
    padding: '4px 12px',
    fontSize: '12px',
    color: theme.palette.text.secondary,
    textTransform: 'none',
  },
  sectionDivider: {
    width: '100%',
    height: '1px',
    background: theme.palette.divider,
    margin: '8px 0',
  }
}));

const ReactionPicker = ({ anchorEl, open, onClose, onReactionSelect }) => {
  const classes = useStyles();
  const [showMoreReactions, setShowMoreReactions] = useState(false);

  // Reações principais (mais usadas)
  const primaryReactions = ['😀', '😂', '❤️', '👍', '🎉', '😢'];

  // Reações expandidas organizadas por categorias
  const categoryReactions = {
    faces: ['😀', '😂', '🥰', '😍', '🤩', '😎', '🤔', '😮', '😱', '😢', '😡', '🥳'],
    gestures: ['👍', '👎', '👏', '🙌', '👌', '✌️', '🤝', '💪', '🙏', '👋'],
    hearts: ['❤️', '💙', '💚', '💛', '🧡', '💜', '🤍', '🖤', '💖', '💕'],
    celebrations: ['🎉', '🎊', '🥳', '🎈', '🎆', '✨', '🌟', '⭐', '🔥', '💥'],
    objects: ['💯', '💎', '🏆', '🎯', '⚡', '🌈', '☀️', '🌙', '💤', '💫']
  };

  const allReactions = Object.values(categoryReactions).flat();

  const handleReactionClick = (reaction) => {
    onReactionSelect(reaction);
    onClose();
  };

  const toggleExpanded = () => {
    setShowMoreReactions(!showMoreReactions);
  };

  const reactionsToShow = showMoreReactions ? allReactions : primaryReactions;

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      PaperProps={{
        className: `${classes.popoverPaper} ${!showMoreReactions ? 'compact' : ''}`
      }}
    >
      {!showMoreReactions ? (
        // Vista compacta - reações principais
        <Grid container spacing={1}>
          {primaryReactions.map((reaction, index) => (
            <Grid item key={`primary-${reaction}-${index}`}>
              <IconButton
                className={classes.reactionButton}
                onClick={() => handleReactionClick(reaction)}
              >
                {reaction}
              </IconButton>
            </Grid>
          ))}

          <Grid item>
            <IconButton
              className={classes.expandButton}
              onClick={toggleExpanded}
              title="Ver mais reações"
            >
              <AddCircleOutline />
            </IconButton>
          </Grid>
        </Grid>
      ) : (
        // Vista expandida - todas as reações por categoria
        <div>
          {Object.entries(categoryReactions).map(([category, reactions], categoryIndex) => (
            <div key={`category-${category}`}>
              {categoryIndex > 0 && <div className={classes.sectionDivider} />}

              <Grid container spacing={1} style={{ marginBottom: '8px' }}>
                {reactions.map((reaction, index) => (
                  <Grid item key={`${category}-${reaction}-${index}`}>
                    <IconButton
                      className={classes.reactionButton}
                      onClick={() => handleReactionClick(reaction)}
                    >
                      {reaction}
                    </IconButton>
                  </Grid>
                ))}
              </Grid>
            </div>
          ))}

          <div style={{ textAlign: 'center', marginTop: '8px' }}>
            <IconButton
              className={classes.collapseButton}
              onClick={toggleExpanded}
              size="small"
            >
              <ExpandLess style={{ marginRight: '4px' }} />
              <Typography variant="caption">
                Mostrar Menos
              </Typography>
            </IconButton>
          </div>
        </div>
      )}
    </Popover>
  );
};

export default ReactionPicker;